export default __webpack_public_path__ + "static/media/double.2ba6c8e0.svg";